import { Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './layout/ProtectedRoute';
import { Shell } from './layout/Shell';
import { AuditLog } from './routes/AuditLog';
import { AuthCallback } from './routes/AuthCallback';
import { AuthLogin } from './routes/AuthLogin';
import { Dashboard } from './routes/Dashboard';
import { DebugPage } from './routes/debug';
import { LineUserDetail } from './routes/LineUserDetail';
import { LineUserList } from './routes/LineUserList';
import { Placeholder } from './routes/Placeholder';
import { CategoryEdit } from './routes/prompts/CategoryEdit';
import { CategoryNew } from './routes/prompts/CategoryNew';
import { CommonEdit } from './routes/prompts/CommonEdit';
import { PromptsList } from './routes/prompts/list';
import { PromptHistoryModal } from './routes/prompts/PromptHistoryModal';
import { TemplateEdit } from './routes/templates/edit';
import { HistoryModal } from './routes/templates/HistoryModal';
import { TemplatesList } from './routes/templates/list';
import { Users } from './routes/Users';

export function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/auth/login" element={<AuthLogin />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route
        element={
          <ProtectedRoute>
            <Shell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="line-users" element={<LineUserList />} />
        <Route path="line-users/:userId" element={<LineUserDetail />} />
        <Route path="templates" element={<TemplatesList />} />
        <Route path="templates/:key" element={<TemplateEdit />} />
        <Route path="templates/:key/history" element={<HistoryModal />} />
        <Route
          path="flow"
          element={
            <ProtectedRoute minRole="editor">
              <Placeholder title="フロー編集" />
            </ProtectedRoute>
          }
        />
        <Route path="prompts" element={<PromptsList />} />
        <Route path="prompts/common" element={<CommonEdit />} />
        <Route path="prompts/common/history" element={<PromptHistoryModal kind="common" />} />
        <Route
          path="prompts/categories/new"
          element={
            <ProtectedRoute minRole="editor">
              <CategoryNew />
            </ProtectedRoute>
          }
        />
        <Route path="prompts/categories/:id" element={<CategoryEdit />} />
        <Route
          path="prompts/categories/:id/history"
          element={<PromptHistoryModal kind="category" />}
        />
        <Route
          path="audit"
          element={
            <ProtectedRoute minRole="editor">
              <AuditLog />
            </ProtectedRoute>
          }
        />
        <Route
          path="users"
          element={
            <ProtectedRoute minRole="admin">
              <Users />
            </ProtectedRoute>
          }
        />
        <Route
          path="debug"
          element={
            <ProtectedRoute minRole="admin">
              <DebugPage />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="*" element={<main className="p-8">Not Found</main>} />
    </Routes>
  );
}
